module.exports = __webpack_public_path__ + "img/footer-1.e44d0626.svg";